import { Link } from 'react-router-dom';

export default function Footer() {
  const serviceLinks = [
    { label: 'Food Aid', path: '/services' },
    { label: 'Education Support', path: '/services' },
    { label: 'Disaster Relief', path: '/services' },
    { label: 'Pet Rescue', path: '/services' },
  ];

  const orgLinks = [
    { label: 'About Us', path: '/about' },
    { label: 'Our Team', path: '/about' },
    { label: 'Impact Report', path: '/about' },
    { label: 'Partners', path: '/about' },
  ];

  const getInvolved = [
    { label: 'Donate', path: '/donate' },
    { label: 'Volunteer', path: '/volunteer' },
    { label: 'Fundraise', path: '/donate' },
    { label: 'Corporate Giving', path: '/contact' },
  ];

  const supportLinks = [
    { label: 'Contact Us', path: '/contact' },
    { label: 'FAQs', path: '/contact' },
    { label: 'Privacy Policy', path: '/' },
    { label: 'Terms of Use', path: '/' },
  ];

  return (
    <footer className="bg-gray-900 text-white">
      {/* Upper Navigation Area */}
      <div className="w-full px-6 md:px-10 pt-16 pb-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h4 className="font-semibold text-lg mb-4">Services</h4>
            <div className="h-px bg-white/20 mb-5"></div>
            <ul className="space-y-3">
              {serviceLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.path} className="text-white/60 hover:text-brand-300 transition-colors text-sm">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-lg mb-4">Organization</h4>
            <div className="h-px bg-white/20 mb-5"></div>
            <ul className="space-y-3">
              {orgLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.path} className="text-white/60 hover:text-brand-300 transition-colors text-sm">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-lg mb-4">Get Involved</h4>
            <div className="h-px bg-white/20 mb-5"></div>
            <ul className="space-y-3">
              {getInvolved.map((link) => (
                <li key={link.label}>
                  <Link to={link.path} className="text-white/60 hover:text-brand-300 transition-colors text-sm">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-lg mb-4">Support</h4>
            <div className="h-px bg-white/20 mb-5"></div>
            <ul className="space-y-3">
              {supportLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.path} className="text-white/60 hover:text-brand-300 transition-colors text-sm">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Branding Area */}
      <div className="w-full px-6 md:px-10 py-10 border-t border-white/10">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
          <div>
            <div className="flex items-baseline gap-2">
              <span className="text-4xl md:text-5xl font-serif font-bold text-white">KELAB</span>
            </div>
            <div className="flex items-baseline gap-2">
              <span className="text-2xl md:text-3xl font-serif font-light italic text-brand-400">IKATAN BINA INSAN</span>
            </div>
            <div className="flex items-center gap-3 mt-4">
              <div className="h-px w-12 bg-brand-400"></div>
              <p className="text-white/50 text-sm">
                Building communities through compassion since 2015
              </p>
            </div>
          </div>

          <div className="flex flex-col items-start lg:items-end gap-5">
            <div className="text-right space-y-1">
              <p className="text-white/40 text-sm">
                &copy; {new Date().getFullYear()} KELAB IKATAN BINA INSAN. All rights reserved.
              </p>
              <p className="text-white/30 text-xs">
                Registered with Registrar of Societies Malaysia &middot; PPM-008-10-01052015
              </p>
              <p className="text-white/50 text-sm mt-2">
                <i className="ri-map-pin-line mr-1.5"></i>
                No.7, Jalan Kiai Khusairy KS03, Off Jalan Hassan, Sg Udang 41250 Klang, Selangor
              </p>
              <p className="text-white/50 text-sm">
                <i className="ri-mail-line mr-1.5"></i>
                hq@ikataninsan.org
              </p>
              <p className="text-white/50 text-sm">
                <i className="ri-phone-line mr-1.5"></i>
                +603-399 5869
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}